// App.js

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppProvider } from "./state";
import { Stand } from "./Steps/Stand";
import { Data } from "./Steps/Data";
import { Confirm } from "./Steps/Confirm";
import { Stepper } from "./Steps/Stepper";
export const App = () => {
    return (
        <div className="App">
            <AppProvider>
                <Router basename='deelnemen/direct-inschrijven/'>
                    <Stepper />
                    <div className="row">
                        <div className="checkout__form mt-5">
                            <Routes>
                                <Route path="/" element={<Stand />} />
                                <Route path="/gegevens" element={<Data />} />
                                <Route path="/samenvatting" element={<Confirm />} />
                            </Routes>
                        </div>
                    </div>
                </Router>
            </AppProvider>
        </div>
    );
};
